const priceMapping = {
    // 4 columns - price for 4 columns
    '4x4': 'price_1QcVq3SGC3dfhjBhLxcsIyXJ', //4

    // Format: rows x columns -> column-based pricing
    // 4 columns in second position
    '5x4': 'price_1QcVq3SGC3dfhjBhLxcsIyXJ', //4
    '6x4': 'price_1QcVq3SGC3dfhjBhLxcsIyXJ', //4
    '7x4': 'price_1QcVq3SGC3dfhjBhLxcsIyXJ', //4
    '8x4': 'price_1QcVq3SGC3dfhjBhLxcsIyXJ', //4
    '9x4': 'price_1QcVq3SGC3dfhjBhLxcsIyXJ', //4
    '10x4': 'price_1QcVq3SGC3dfhjBhLxcsIyXJ', //4
    '11x4': 'price_1QcVq3SGC3dfhjBhLxcsIyXJ', //4
    '12x4': 'price_1QcVq3SGC3dfhjBhLxcsIyXJ', //4
    '13x4': 'price_1QcVq3SGC3dfhjBhLxcsIyXJ', //4
    
    // 5 columns in second position
    '4x5': 'price_1QcVq3SGC3dfhjBhRIYWItqs', //5
    '5x5': 'price_1QcVq3SGC3dfhjBhRIYWItqs', //5
    '6x5': 'price_1QcVq3SGC3dfhjBhRIYWItqs', //5
    '7x5': 'price_1QcVq3SGC3dfhjBhRIYWItqs', //5
    '8x5': 'price_1QcVq3SGC3dfhjBhRIYWItqs', //5
    '9x5': 'price_1QcVq3SGC3dfhjBhRIYWItqs', //5
    '10x5': 'price_1QcVq3SGC3dfhjBhRIYWItqs', //5
    '11x5': 'price_1QcVq3SGC3dfhjBhRIYWItqs', //5
    '12x5': 'price_1QcVq3SGC3dfhjBhRIYWItqs', //5
    '13x5': 'price_1QcVq3SGC3dfhjBhRIYWItqs', //5
    
    // 6 columns in second position
    '4x6': 'price_1QcVq3SGC3dfhjBhK0mzWRqx', //6
    '5x6': 'price_1QcVq3SGC3dfhjBhK0mzWRqx', //6
    '6x6': 'price_1QcVq3SGC3dfhjBhK0mzWRqx', //6
    '7x6': 'price_1QcVq3SGC3dfhjBhK0mzWRqx', //6
    '8x6': 'price_1QcVq3SGC3dfhjBhK0mzWRqx', //6
    '9x6': 'price_1QcVq3SGC3dfhjBhK0mzWRqx', //6
    '10x6': 'price_1QcVq3SGC3dfhjBhK0mzWRqx', //6
    '11x6': 'price_1QcVq3SGC3dfhjBhK0mzWRqx', //6
    '12x6': 'price_1QcVq3SGC3dfhjBhK0mzWRqx', //6
    '13x6': 'price_1QcVq3SGC3dfhjBhK0mzWRqx', //6
    
    // 7 columns in second position
    '4x7': 'price_1QcVq3SGC3dfhjBh8a5T2M4a', //7
    '5x7': 'price_1QcVq3SGC3dfhjBh8a5T2M4a', //7
    '6x7': 'price_1QcVq3SGC3dfhjBh8a5T2M4a', //7
    '7x7': 'price_1QcVq3SGC3dfhjBh8a5T2M4a', //7
    '8x7': 'price_1QcVq3SGC3dfhjBh8a5T2M4a', //7
    '9x7': 'price_1QcVq3SGC3dfhjBh8a5T2M4a', //7
    '10x7': 'price_1QcVq3SGC3dfhjBh8a5T2M4a', //7
    '11x7': 'price_1QcVq3SGC3dfhjBh8a5T2M4a', //7
    '12x7': 'price_1QcVq3SGC3dfhjBh8a5T2M4a', //7
    '13x7': 'price_1QcVq3SGC3dfhjBh8a5T2M4a', //7
    
    // 8 columns in second position
    '4x8': 'price_1QcVq3SGC3dfhjBhfZBW5EWH', //8
    '5x8': 'price_1QcVq3SGC3dfhjBhfZBW5EWH', //8
    '6x8': 'price_1QcVq3SGC3dfhjBhfZBW5EWH', //8
    '7x8': 'price_1QcVq3SGC3dfhjBhfZBW5EWH', //8
    '8x8': 'price_1QcVq3SGC3dfhjBhfZBW5EWH', //8
    '9x8': 'price_1QcVq3SGC3dfhjBhfZBW5EWH', //8
    '10x8': 'price_1QcVq3SGC3dfhjBhfZBW5EWH', //8
    '11x8': 'price_1QcVq3SGC3dfhjBhfZBW5EWH', //8
    '12x8': 'price_1QcVq3SGC3dfhjBhfZBW5EWH', //8
    '13x8': 'price_1QcVq3SGC3dfhjBhfZBW5EWH', //8
    
    // 9 columns in second position
    '4x9': 'price_1QcVq3SGC3dfhjBhaKQVf5bF', //9
    '5x9': 'price_1QcVq3SGC3dfhjBhaKQVf5bF', //9
    '6x9': 'price_1QcVq3SGC3dfhjBhaKQVf5bF', //9
    '7x9': 'price_1QcVq3SGC3dfhjBhaKQVf5bF', //9
    '8x9': 'price_1QcVq3SGC3dfhjBhaKQVf5bF', //9
    '9x9': 'price_1QcVq3SGC3dfhjBhaKQVf5bF', //9
    '10x9': 'price_1QcVq3SGC3dfhjBhaKQVf5bF', //9
    '11x9': 'price_1QcVq3SGC3dfhjBhaKQVf5bF', //9
    '12x9': 'price_1QcVq3SGC3dfhjBhaKQVf5bF', //9
    '13x9': 'price_1QcVq3SGC3dfhjBhaKQVf5bF', //9
    
    // 10 columns in second position
    '4x10': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '5x10': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '6x10': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '7x10': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '8x10': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '9x10': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '10x10': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '11x10': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '12x10': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '13x10': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    
    // 11 columns in second position
    '4x11': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '5x11': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '6x11': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '7x11': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '8x11': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '9x11': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '10x11': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '11x11': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '12x11': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '13x11': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    
    // 12 columns in second position
    '4x12': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '5x12': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '6x12': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '7x12': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '8x12': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '9x12': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '10x12': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '11x12': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '12x12': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '13x12': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    
    // 13 columns in second position
    '4x13': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '5x13': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '6x13': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '7x13': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '8x13': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '9x13': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '10x13': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '11x13': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '12x13': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
    '13x13': 'price_1QcVq3SGC3dfhjBhZ9pjtLMp', //10
};

export default priceMapping;
